var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.entry.type === 'reassignment_transfer' ? _c('ChatBubble', {
    attrs: {
      "avatar-text": `⚡`,
      "sent-date-unix": _vm.entry.sentat,
      "communication-role": _vm.communicationRole,
      "message-type": _vm.CHAT_TYPE.EVENT,
      "event-name": _vm.eventName,
      "hide-name": ""
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function () {
        return [_c('div', {
          staticClass: "reassignment-card tw-rounded tw-px-4 tw-py-3"
        }, [_c('p', {
          staticClass: "tw-mb-0"
        }, [_c('span', {
          staticClass: "tw-mb-1 tw-block"
        }, [_vm._v(" Patient has been reassigned to "), _c('span', {
          staticClass: "tw-font-semibold"
        }, [_vm._v(" Dr. " + _vm._s(_vm.entry.custommessage.message.doctorto) + " ")]), _vm.entry.custommessage.message.reassignmentstatus !== 'RETURNED' ? [_vm._v(" " + _vm._s(_vm.entry.custommessage.message.assignmenttype === 'TEMPORARY' ? 'temporarily' : 'permanently') + " ")] : _vm._e()], 2), _vm.entry.custommessage.message.assignmenttype === 'TEMPORARY' && _vm.entry.custommessage.message.reassignmentstatus !== 'RETURNED' ? _c('small', {
          staticClass: "tw-block tw-text-left tw-text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.entry.custommessage.message.startdatestamp)) + " to " + _vm._s(_vm.formatDate(_vm.entry.custommessage.message.enddatestamp)) + " ")]) : _vm._e()])])];
      },
      proxy: true
    }], null, false, 2755476331)
  }) : _c('ChatBubble', {
    attrs: {
      "avatar-url": _vm.entry.profileurl,
      "avatar-text": _vm.avatarText,
      "sent-date-unix": _vm.entry.sentat,
      "message": _vm.entry.message,
      "communication-role": _vm.communicationRole,
      "bubble-background-class": _vm.backgroundClass(),
      "attachments": _vm.entry.attachment,
      "sender-name": _vm.senderName
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };